import React from 'react';
import FieldTypeSelector from '../investments/addInvestment/inputs/Index';

import {
  commonFieldConfig,
  commonFieldTypes,
} from '../investments/addInvestment/inputs/field.config';
import { AppDispatch, RootState } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import CreateApi from '../../api/genericApis/Create.api';
import Swal from 'sweetalert2';
import { ModuleType } from '../../api/modules.types';
import {
  updateFieldValue,
  clearCompletedProjectsData,
} from '../../redux/completedProjects/completedProjectsSlice';

export default function AddProject() {
  const dispatch: AppDispatch = useDispatch();
  const projectData = useSelector(
    (state: RootState) => state.completedProjects,
  );

  // Handle input changes for fields
  const handleInputChange = ({
    e,
    field,
    lang,
    isSameValue,
  }: {
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
    field: string;
    lang: 'ar' | 'en';
    isSameValue: boolean;
  }) => {
    const { value } = e.target;

    dispatch(
      updateFieldValue({
        language: lang,
        field,
        value,
        isSameValue,
      }),
    );
  };

  const completedProjectFieldsEn = [
    {
      label: 'Project Name',
      value: projectData.en.projectName,
      field: 'projectName',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'Project Description',
      value: projectData.en.projectDescription,
      field: 'projectDescription',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'Project Location',
      value: projectData.en.projectLocation,
      field: 'projectLocation',
      config: { ...commonFieldConfig['en'][commonFieldTypes.dropdown] },
    },
  ];

  const completedProjectFieldsAr = [
    {
      label: 'اسم المشروع',
      value: projectData.ar.projectName,
      field: 'projectName',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
    {
      label: 'وصف المشروع',
      value: projectData.ar.projectDescription,
      field: 'projectDescription',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
    // {
    //   label: 'موقع المشروع',
    //   value: projectData.ar.projectLocation,
    //   field: 'projectLocation',
    //   config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    // },
  ];

  const imageSection = {
    label: 'Project Image URL',
    value: projectData.en.projectImage,
    field: 'projectImage',
    config: { ...commonFieldConfig['en'][commonFieldTypes.image] },
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Confirm with SweetAlert before submitting
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to submit the project data?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, submit!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        CreateApi({ moduleType: ModuleType.project, data: projectData })
          .then((response) => {
            // On success
            Swal.fire({
              title: 'Success!',
              text: 'Project has been successfully added.',
              icon: 'success',
              confirmButtonText: 'Ok',
            });

            // Clear fields after success
            dispatch(clearCompletedProjectsData());
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error!',
              text: 'There was an issue submitting the project. Please try again.',
              icon: 'error',
              confirmButtonText: 'Ok',
            });
          });
      }
    });
  };

  return (
    <section className="mb-5 d-flex flex-column">
      <h3 className="mb-3">Add Service</h3>
      <div className="row">
        <div className="col-md-6">
          {completedProjectFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              fieldName={field.field}
              label={field.label}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  field: field.field,
                  lang: 'en',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>
        <div className="col-md-6" dir="rtl">
          {completedProjectFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              fieldName={field.field}
              label={field.label}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  field: field.field,
                  lang: 'ar',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>
      </div>

      <div className="mt-3">
        {imageSection && (
          <FieldTypeSelector
            fieldName={imageSection.field}
            label={imageSection.label}
            value={imageSection.value}
            config={imageSection.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                field: imageSection.field,
                lang: 'en',
                isSameValue: imageSection.config.isSameValue,
              })
            }
          />
        )}
      </div>

      <button
        onClick={handleSubmit}
        className="btn btn-primary mt-4 align-self-center p-2"
      >
        Submit
      </button>
    </section>
  );
}
